module.exports = __webpack_public_path__ + "img/arrow-up-white.6b35c268.svg";